import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

// Old bookmarks: /resume/:id/contact etc. → the section anchor on EditorPage.
const LegacySectionRedirect = () => {
    const { resumeId, section } = useParams();
    return <Navigate to={`/resume/${resumeId}#${section}`} replace />;
};

export default LegacySectionRedirect;
